import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from "../svgs/C1_Roller_shutter_teleruptor_force_descent.svg"

const C1Rollershutterteleruptorforcedescent: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 76 76'} component={Icon} {...props} fill="currentColor" />
export default C1Rollershutterteleruptorforcedescent
